import { render, staticRenderFns } from "./search.vue?vue&type=template&id=053d1a3c&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\works\\private\\kurlakk\\site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053d1a3c')) {
      api.createRecord('053d1a3c', component.options)
    } else {
      api.reload('053d1a3c', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=053d1a3c&", function () {
      api.rerender('053d1a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/web/vue/views/search/search.vue"
export default component.exports